import Helpers from "commons/helpers";
import Constants from "constants/index";
import IdentityService from "./identity.service";
import { IUserDetailResponse } from "commons/interfaces";

class UserService extends IdentityService {

    public getPaged = async (data: {
        clientId?: string;
        serviceCode?: string;
        organizationId?: string;
        groupId?: string;
        fullName?: string;
        roleCode?: string;
        searchText?: string;
        listStatus?: number[];
        selectedIds?: string[];
        roleIncludes?: string[];
        roleNotIncludes?: string[];
        hasGroupDefault?: number;
        nonHierarchical?: number;
        groupIds?: string[];
        forceRoles?: string[];
        orderby?: string;
        pageSize?: number;
        pageNumber?: number;
    }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.USER.GET_PAGED + `${query ? "?" : ""}${query}`,
        });
        return result.data.result;
    };

    public getDetail = async (data: { id: string; clientId?: string; organizationId?: string }): Promise<IUserDetailResponse> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.USER.DETAIL + `${query ? "?" : ""}${query}`,
        });
        return result.data.result;
    };

    public mergeUser = async (fromUserName: string) => {
        const result = await this.api.post({
            path: Constants.ApiPath.USER.MERGE_USER,
            data: { fromUserName }
        });
        return result.data.result;
    }
}

export default UserService;
